import { Link } from "react-router-dom";
import Icon from "./Icon";

// items: array of { label, to? } — items without `to` render as plain text (current page).
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="breadcrumb-item">
            {item.to && !isLast ? (
              <Link to={item.to} className="breadcrumb-link">{item.label}</Link>
            ) : (
              <span className={isLast ? "breadcrumb-current" : "breadcrumb-link"}>{item.label}</span>
            )}
            {!isLast && (
              <Icon name="chevron-right" size={12} className="breadcrumb-sep" />
            )}
          </span>
        );
      })}
    </nav>
  );
}
